export function useNumber() {
	const withSpaces = (number: number) => {
		return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
	}

	return {
		withSpaces
	};
}
